<div
  class="cb-checkbox-container"
  [ngClass]="['cb-size-' + size(), 'cb-color-' + color()]"
  [class.cb-required]="required()"
  [class.cb-tri-state]="tripleState() && value == null"
  [class.cb-disabled]="disabled()"
  [class.cb-error]="error()"
  [class.cb-checked]="value"
  (click)="toggleValue($event)"
>
  <div class="cb-checkbox">
    <ng-container
      *ngIf="tripleState() && value == null; else CheckmarkTemplate"
    >
      <cb-icon name="cb cb-base-outline-minus"></cb-icon>
    </ng-container>
    <ng-template #CheckmarkTemplate>
      <cb-icon name="cb cb-base-outline-check"></cb-icon>
    </ng-template>
  </div>
  <ng-container
    *ngIf="(label() !== undefined && label() !== null) || helpText()"
  >
    <label [for]="id">
      <h6
        *ngIf="label() !== undefined && label() !== null"
        [innerHTML]="label()"
      ></h6>
      <p *ngIf="helpText()">{{ helpText() }}</p>
    </label>
  </ng-container>
</div>
